/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import {
  ActionManager,
  ActionManagerFn,
  AliasType,
} from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionQueryAdditionalDatasource';

const ActionQueryAdditionalDatasourceManager: ActionManagerFn<
  'ActionQueryAdditionalDatasource'
> = (platform: Platform): ActionManager<'ActionQueryAdditionalDatasource'> => {
  return {
    ...baseActionManager(platform, 'ActionQueryAdditionalDatasource'),
    name: 'Query Additional Datasource',
    defaultValue,
    props: {
      ...baseActionProps,
      targetDataSourceAlias: {
        category: 'Data',
        label: 'Target DataSource Alias',
        required: true,
        type: 'DataSourceAliasChooser',
        allowedTypes: [
          'CloudDataStore',
          'DataStore',
          'LocalDataStore',
          'ReadOnlyDataStore',
        ],
      },
    },
    getDataSourceAliasProperty: (aliasType: AliasType) =>
      aliasType === 'STORE'
        ? { aliasProp: 'alias', embeddedPageIdProp: 'embeddedPageId' } // TODO: Add embeddedPageId prop
        : undefined,
    isDataSourceAliasUsed: (item, alias) =>
      item.props.targetDataSourceAlias === alias,
    icon: { iconName: 'search-plus' },
    description:
      'Use this action to Query Additional Datasources with the same filters as the base Smart Search store.',
  };
};

export default ActionQueryAdditionalDatasourceManager;
